import { render, staticRenderFns } from "./quickSearches.vue?vue&type=template&id=a5a2cea2&"
import script from "./quickSearches.vue?vue&type=script&lang=js&"
export * from "./quickSearches.vue?vue&type=script&lang=js&"
import style0 from "./quickSearches.vue?vue&type=style&index=0&id=a5a2cea2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports